import { getUserFromEvent } from "./auth.server";

export type SessionCheck = { ok: true; userId: number } | { ok: false };

// Asked by the browser before it creates anything (a project, a certificate, an
// assessment). The dashboard only checks the login when a page is loaded, so a tab
// left open until the Cognito session has gone can still call the server functions,
// and its user id is then 0 (or somebody else's). This answers from the cookie, which
// is what the server trusts, and hands back the user id to write under.
export const checkSession = async (): Promise<SessionCheck> => {
	"use server";

	const user: any = await getUserFromEvent();

	// Same test as the dashboard middleware. The development cookie carries no exp.
	const expired = user?.exp !== undefined && user.exp < Date.now() / 1000;

	if (!user || expired || !(user.userId > 0)) return { ok: false };

	return { ok: true, userId: user.userId };
};
